import filter from 'lodash/filter'
import map from 'lodash/map'
import React, { FC, memo, useState } from 'react'

import SvgMinus from '@Assets/SVG/Minus'
import SvgPlus from '@Assets/SVG/Plus'
import { ProductBundleItem } from '@Domains/Product/Features/Display/ProductBundleItem/ProductBundleItem'
import { AttributePrice, ProductWithQuantity } from '@Generated/graphql'
import { useTranslation } from '@Globals/Translations'

import styles from './ProductBundle.module.scss'

interface ProductBundleProps {
  bundleItems?: ProductWithQuantity[]
  bundlePrice?: AttributePrice
  disablePrices?: boolean
  disableProductLinks?: boolean
}

export const ProductBundle: FC<ProductBundleProps> = memo(({
  bundleItems,
  bundlePrice,
  disablePrices = false,
  disableProductLinks = false,
}) => {
  const { t } = useTranslation()

  const [isExpanded, setIsExpanded] = useState(false)

  const onlyItemsWithProductData = filter(bundleItems, item => !!item.product)

  if (!onlyItemsWithProductData?.length) {
    return null
  }

  // @ts-ignore - "originalPrice" is set dynamically in the query, and does not have a type.
  const summaryValue = bundlePrice?.originalPrice?.discount?.format || bundlePrice?.originalPrice?.format || ''

  return (
    <div>
      <div className={styles.title}>
        {t('products:PP_PACKAGE_CONTAINS')}
      </div>
      <div className={styles.list}>
        {map(onlyItemsWithProductData, ({ product: productData, quantity }, index) => {
          // @ts-ignore - "image" is set dynamically in the query, and does not have a type. ¯\_(ツ)_/¯
          const { id, image = '', name, url = '' } = productData
          const link = url || ''
          const currentPrice = productData?.masterVariant?.price?.discount?.format || productData?.masterVariant?.price?.format || ''

          return (
            <ProductBundleItem
              key={id}
              expanded={isExpanded || index < 3}
              image={image}
              link={disableProductLinks ? '' : link}
              price={!disablePrices ? currentPrice : undefined}
              title={name}
            >
              {(quantity || 0) > 1 ? t('products:PP_BUNDLE_ITEM_QUANTITY', '{{arg1}}x {{arg2}}', { arg1: quantity, arg2: name }) : name}
            </ProductBundleItem>
          )
        })}

        {onlyItemsWithProductData.length > 3 && (
          <button
            className={styles.toggle}
            onClick={() => setIsExpanded(!isExpanded)}
            type="button"
          >
            {isExpanded ? t('cms:SHOW_LESS_LABEL', 'Show more') : t('cms:SHOW_MORE_LABEL', 'Show less')}

            {isExpanded ? (<SvgMinus />) : (<SvgPlus />)}
          </button>
        )}

        {(summaryValue && !disablePrices) && (
          <div className={styles.summary}>
            {t('common:BUNDLE_COMBINED_VALUE')}
            <strong>
              {summaryValue}
            </strong>
          </div>
        )}

      </div>
    </div>
  )
})
